module.exports = "/assets/3a26bae932ea3a36090286216322307f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XL.png
// module id = 3118
// module chunks = 0